import gql from 'graphql-tag'

export const demoTokenUpdate = gql`
  mutation demoTokenUpdate($data: DemoTokenUpdateInput!) {
    demoTokenUpdate(input: $data) {
      success
    }
  }
`
